import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { filterToQuery, type RevenueFilterState } from "../lib/revenue-filter";

import { revenueKeys } from "./query-keys";

export function useRevenueReport(filter: RevenueFilterState) {
  return useQuery({
    queryKey: revenueKeys.list(filter),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/reports/revenue", {
        params: { query: filterToQuery(filter) },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
